const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/defs/kisim.ts';
import { KeyValuePair, ValueSet } from './generalDefs';

export enum ORDER_KAT {
    MEDI = 'MEDI',
    MSNHK = 'MSNHK',
    ORDHK = 'ORDHK',
    ORDLAB = 'ORDLAB',
}

export enum FKEY {
    '1MSST' = '1MSST',
    '10MPN' = '10MPN',
    AESTR = 'AESTR',
    AF = 'AF',
    ALLG = 'ALLG',
    AUSBEM = 'AUSBEM',
    BARTEL = 'BARTEL',
    BBS = 'BBS',
    BD = 'BD',
    BIO = 'BIO',
    BLTSC = 'BLTSC',
    BMI = 'BMI',
    BRDSK = 'BRDSK',
    BZ = 'BZ',
    CAM = 'CAM',
    CAT = 'CAT',
    DBZ = 'DBZ',
    DEMMI = 'DEMMI',
    DOS = 'DOS',
    FLBILANZ = 'FLBILANZ',
    FLBILBLUTV = 'FLBILBLUTV',
    FLBILSPRE = 'FLBILSPRE',
    FLBILTRINK = 'FLBILTRINK',
    FLBILURIN = 'FLBILURIN',
    FPULS = 'FPULS',
    GCS = 'GCS',
    GCSKI = 'GCSKI',
    GEWICHT = 'GEWICHT',
    GRO = 'GRO',
    HADS = 'HADS',
    HRZFR = 'HRZFR',
    INSTSYSW = 'INSTSYSW',
    INSTVW = 'INSTVW',
    INSTKONTR = 'INSTKONTR',
    INSTAUSF = 'INSTAUSF',
    KONTR = 'KONTR',
    KOSBEGL = 'KOSBEGL',
    KOST = 'KOST',
    KPS = 'KPS',
    LAB = 'LAB',
    LAGER = 'LAGER',
    MUMAK = 'MUMAK',
    MUMRK = 'MUMRK',
    MIKTN = 'MIKTN',
    MIKTNE = 'MIKTNE',
    MOB = 'MOB',
    MOBIL = 'MOBIL',
    MORSE = 'MORSE',
    MSQMRZCAM = 'MSQMRZCAM',
    NRSC = 'NRSC',
    NUDES = 'NUDES',
    O2SAT = 'O2SAT',
    O2TH = 'O2TH',
    PHABTH = 'PHABTH',
    PROE = 'PROE',
    PULS = 'PULS',
    PULSINV = 'PULSINV',
    PULSOXY = 'PULSOXY',
    PUPSR = 'PUPSR',
    SNB = 'SNB',
    STUHL = 'STUHL',
    SZERF = 'SZERF',
    TEMP = 'TEMP',
    TEMPR = 'TEMPR',
    UEBWSAM = 'UEBWSAM',
    Urinstatus = 'Urinstatus',
    URKON = 'URKON',
    WICKEL = 'WICKEL',
    WUND = 'WUND',
    WUNDDOKU = 'WUNDDOKU',
    WUNDFADE = 'WUNDFADE',
    WUNDSPUEL = 'WUNDSPUEL',
    WUNDVAC = 'WUNDVAC',
    WUNDVW = 'WUNDVW',
}

export enum VERLAUFS_PARAMETER {
    BD = FKEY.BD,
    BZ = FKEY.BZ,
    GEWICHT = FKEY.GEWICHT,
    GRO = FKEY.GRO,
    O2SAT = FKEY.O2SAT,
    PULS = FKEY.PULS,
    PULSINV = FKEY.PULSINV,
    PULSOXY = FKEY.PULSOXY,
    STUHL = FKEY.STUHL,
    TEMP = FKEY.TEMP,
    TEMPR = FKEY.TEMPR,
    HRZFR = FKEY.HRZFR,
}

// Exporting some useful values

export const fkeys: string[] = [];
for (const fkey in FKEY) fkeys.push(fkey);

export const verlaufsParameterFkeys: string[] = [];
for (const verlaufsParameter in VERLAUFS_PARAMETER) verlaufsParameterFkeys.push(verlaufsParameter);

export interface KISIMObject extends KeyValuePair {
    CONTENT?: KeyValuePair;
}

export interface CaseData extends KISIMObject {
    FALLART: string;
    FALLNR: string;
    KLASSE: string;
    PATNR: string;
    STARTDAT: string;
    STOPDAT: string;
}

export interface AppointmentData extends KISIMObject {
    PATNR: string;
    FALLNR: string;
    TERMNR: string;
    SENDER: string;
    KAT: string;
    FKEY: string;
    TYP: string;
    COMM: string;
    TERMTXT: string;
    FCODE: string;
    KIND: string;
    LAST_MODIFIED: string;
    RESNAME: string;
    STARTDAT: string;
    STOPDAT: string;
    STAT: string;
    PROC1: string;
    STAT1: string;
    PROC2: string;
    STAT2: string;
    RIGHTS: KeyValuePair;
}

export interface EventData extends KISIMObject {
    COMM: string;
    EVENTNR: string;
    EVENTTXT: string;
    FALLNR: string;
    FCODE: string;
    FKEY: string;
    KAT: string;
    KIND: string;
    LAST_MODIFIED: string;
    NAME: string;
    PATNR: string;
    REF_NR: string;
    REF_SENDER: string;
    SENDER: string;
    STARTDAT: string;
    STOPDAT: string;
    STATUS: string;
    UNIT: string;
    VAL: string;
    RIGHTS: KeyValuePair;
}

export type NewEventData = Partial<EventData>;

export interface OrderData extends KISIMObject {
    COMM: string;
    FALLNR: string;
    FCODE: string;
    FKEY: string;
    KAT: string;
    KIND: string;
    LAST_MODIFIED: string;
    NAME: string;
    ORDERNR: string;
    ORDERTXT: string;
    PATNR: string;
    SENDER: string;
    STARTDAT: string;
    STOPDAT: string;
    VISUM: string;
}

export type AppointmentType = 'BELEGUNG' | 'KONS' | 'OPERATION' | 'RES' | 'TRIAGE' | 'VORMERKUNG';

export type AppointmentKat = 'KONS' | 'USER' | 'UZIMMER' | 'VORMERKUNG';

export interface Appointment extends KISIMObject {
    ALLDAYEVENT?: string;
    BEHANDLER?: KeyValuePair[];
    BEMERKUNGEN?: string;
    CONTENT?: {
        AnmInhalt?: {
            Inhalt?: {
                AngabenAufnahme?: {
                    BehandelnderArzt?: {
                        AddressList?: {
                            '1': {
                                Titel?: string;
                                Name?: string;
                                Vorname?: string;
                            };
                        };
                    };
                    Zuweiser?: string;
                };
            };
        };
        Basis?: {
            EintrittDat?: string;
            EintrittTime?: string;
        };
        Display?: string;
        Header?: {
            Klinik?: {
                NAME?: string;
                FKEY?: string;
            };
            Patient?: {
                EMAIL?: string;
            };
            ZustArzt?: {
                DisplayName?: string;
            };
        };
        Status?: {
            Proc1?: {
                NAME: string;
            };
            RessourcenStandort?: {
                Adresse?: string;
                Standort?: string;
                TelefonStandort?: string;
            };
        };
        Telemedizin?: {
            SessionLink?: string;
        };
        TerminartForMakro?: string;
    };
    EINGRIFF?: KeyValuePair[];
    EINTRITTDAT?: string;
    EINTRITTTIME?: string;
    EINTRITTDAT_PATIENT?: string; // Custom property set by client
    EXTERNALLINK?: string;
    FALLART?: CaseType;
    FALLNR?: string;
    KAT?: AppointmentKat;
    KIND?: string;
    OPTEAM?: KeyValuePair[];
    ORT?: KeyValuePair;
    PATNR?: string;
    RESNAME?: string;
    RESSOURCENSTANDORT?: {
        Standort?: string;
        Adresse?: string;
        TelefonStandort?: string;
        KAT?: string;
        FKEY: string;
    };
    STARTDAT: string;
    STAT?: string;
    STOPDAT: string;
    TEILNEHMER?: KeyValuePair;
    TERMKAT?: string;
    TERMNR: string;
    TERMTXT?: string; // FIXME: CHECK IF EXISTING AND NEEDED... note: this is returned for the BookedAppointment
    TITLE?: string;
    SUBLIMDSTATE?: 'READY';
    TYP: AppointmentType;
}

// Coming from StructuredCalendarItems
export interface StructuredAppointment extends Omit<Appointment, 'KIND'> {
    KIND?: {
        TerminartForMakro?: string;
        DISPLAY?: string;
        FKEY?: string;
    };
    STATUS?: {
        NAME?: string;
    };
}

export enum WorkItemTKAT {
    PatAppDocRead = 'PatAppDocRead',
    PatAppECheckin = 'PatAppECheckin',
}

export enum WorkItemRKEY {
    PatDocRead = 'PAT-DOCREAD',
    ECheckin = 'PAT-ECHECKIN',
}

export enum WorkItemStatus {
    done = 'D',
    error = 'E',
    forwarded = 'F',
    inactive = 'I',
    preFinalized = 'P',
    recycle = 'Y',
    replied = 'R',
    unread = 'U',
    update = 'U',
}

export enum CaseType {
    stationary = 'S',
    ambulant = 'A',
    semiStationary = 'T',
    none = '',
}

interface WorkItemContent {
    StopOnNewStart?: string;
    ForceStatus?: string;
    Report?: KeyValuePair;
    Attach?: KeyValuePair;
}

export interface NewWorkItem extends Omit<KISIMObject, 'CONTENT'> {
    DAT?: string;
    SEENDAT?: string;
    FALLNR?: string | undefined;
    FCODE?: string | undefined;
    PATNR?: string | undefined;
    REFNR?: string | undefined;
    RESULT?: string;
    RKAT?: 'USER' | 'POOL';
    RKEY?: WorkItemRKEY;
    SKAT?: 'USER' | 'POOL';
    SKEY?: string | undefined;
    STATUS?: WorkItemStatus | undefined;
    SUBJECT?: string | undefined;
    TKAT?: WorkItemTKAT;
    TKEY?: string | undefined;
    CONTENT?: WorkItemContent;
    EMAIL?: string;
}

export interface WorkItem extends NewWorkItem {
    WORKID: string;
    CONTENT: WorkItemContent;
    TKAT: WorkItemTKAT;
    TKEY: string;
}

export interface DocumentReadWorkItem extends WorkItem {
    RKEY: WorkItemRKEY.PatDocRead;
    TKAT: WorkItemTKAT.PatAppDocRead;
}

interface ECheckinWorkItemContent extends WorkItemContent {
    echeckin: KeyValuePair;
}

export interface ECheckinWorkItem extends WorkItem {
    RKEY: WorkItemRKEY.ECheckin;
    TKAT: WorkItemTKAT.PatAppECheckin;
    CONTENT: ECheckinWorkItemContent;
    TKEY: string;
    FCODE: 'WKFPATINV1';
    RKAT: 'POOL';
    SKAT: 'USER';
    SKEY: 'APITEST';
    ETAG: string;
}

export interface ResponsibilityWorkItem {
    CONTENT: {
        Type: {
            FKEY: string;
            KAT: 'ZUST';
            NAME: string;
            CONTENT: {
                ShortIdent: string;
            };
        };
        SenderDisplayName: string;
        Recipients: KeyValuePair<{
            Kat: 'USER' | 'POOL';
            Key: string;
            DisplayName: string;
        }>;
    };
    ETAG: string;
    FALLNR: string;
    LASTDAT: string;
    PATNAME: string;
    PATNR: string;
    RKAT: 'USER' | 'POOL';
    RKEY: string;
    SKAT: 'USER' | 'POOL';
    SKEY: string;
    STARTDAT: string;
    STATUS: 'A' | 'D' | 'I' | 'F'; // 'F' = handed over (abgegeben); can't be ended server-side
    STOPDAT: string;
    TKAT: 'ZUST';
    TKEY: string;
    VISUM: string;
    WORKID: string;
}

export interface Report extends KISIMObject {
    DAT: string;
    FALLNR: string;
    FCODE: string;
    NAME: string;
    REPORTNR: string;
    SENDER: string;
}

export interface TreatmentReason {
    Duration: {
        Val: string;
        Unit: string;
    };
    Key: string;
    Name: string;
}

export interface MetaKatItem {
    KAT: string;
    FKEY: string;
    NAME: string;
    ICODE: string;
    PCODE: string;
    LEVEL: string;
    STATUS: string;
}

/**
 * One row of the KisMobile/Zustaendigkeit/Types response. Deliberately NOT a MetaKatItem: the endpoint returns
 * neither PCODE nor LEVEL (parentage is the PCODE you requested, not a field), and it adds CHILD/POS/CfgIcode.
 */
export interface ResponsibilityType {
    ICODE: string;
    NAME: string;
    KAT: string; // 'ZUST' for an actual Zuständigkeitstyp, otherwise a structural item (typically 'ST')
    FKEY: string;
    POS: string; // sort order within the level
    CHILD?: string; // '+' = this entry has children that can be loaded with its ICODE as PCODE
    TYP?: string;
    CfgIcode?: string; // key into the response's `cfg` map; only present when includeCfgInResponse was set
}

export interface MetaKatItemReference {
    KAT: string;
    FKEY: string;
    NAME: string;
}

export interface Patient extends KeyValuePair {
    ADRESSZUSATZ: string;
    ANREDE: string;
    ANSCHR2: string;
    BEMERKUNG: string;
    BERUF: string;
    DAT: string;
    EMAIL: string;
    FACHTITEL: string;
    FAX: string;
    GEBDAT: string;
    GEBURTSNAME: string;
    HEIMATORT: string;
    HINWEISE: string;
    KONFESSION: string;
    LAND: string;
    MITARBEITER: string;
    MUTDAT: string;
    MUTVIS: string;
    NAME: string;
    NATIONALITAET: string;
    ORT: string;
    PATNR: string;
    PLZ: string;
    REGION: string;
    SCHLECHTER_ZAHLER: string;
    SEX: string;
    SOZVERSNR: string;
    SPRACHE: string;
    STATUS: string;
    STRASSE: string;
    TELEFON: string;
    TELEFON_G: string;
    TELEFON_M: string;
    TITEL: string;
    TODESDATUM: string;
    VERSTORBEN: string;
    VIP: string;
    VIS: string;
    VORNAME: string;
    ZIVILSTAND: string;
}

export interface User extends KeyValuePair {
    COMM: KeyValuePair;
    EMAIL: string;
    ENDDATE: string;
    ERFDAT: string;
    ERFVIS: string;
    FIRSTDATE: string;
    FIRSTNAME: string;
    FIRSTNAME_SHORT: string;
    FUNCTION: string;
    FUNKEY: string;
    KURZZ: string;
    LASTDATE: string;
    LASTNAME: string;
    LOGINNAME: string;
    MUTDAT: string;
    MUTVIS: string;
    OCODE: string;
    PERSNR: string;
    PWDATE: string;
    RCODE: string;
    ROOM: string;
    SPECIAL: KeyValuePair;
    STATUS: string;
    TEL2: string;
    TELB: string;
    TELS: string;
    TITLE: string;
    TODODAT: string;
    VISUM: string;
}

// Alias types to make usage semantically more meaningful
export type PatNr = string;

/**
 * Kinds of KISIM objects.
 */
export enum KisObjectKind {
    Patient = 1,
    Case,
    Order,
    Event,
    MetaKat,
    Report,
    LabReport,
    Termin,
    WorkItem,
}

/**
 * Kinds of KISIM orders
 */
export enum KisOrderKind {
    medication,
    access, // installation and access
    parameter, // vital and progress parameters
    nutrition,
    specialMeasure,
    woundBandage,
    score,
    bloodProducts,
    pflegeProzess,
    laboratory,
    counter,
}

/**
 * Kinds of KISIM orders
 */
export enum KisEventKind {
    medication,
    access, // installation and access
    parameter, // vital and progress parameters
    nutrition,
    specialMeasure,
    woundBandage,
    score,
    bloodProducts,
    pflegeProzess,
    laboratory,
    counter,
}

/**
 * The primary key of a KISIM patient record.
 */
export interface IKisPatientPK {
    PATNR: string;
}

/**
 * The primary key of a KISIM case record.
 */
export interface IKisCasePK {
    FALLNR: string;
}

/**
 * The primary key of a KISIM order record.
 */
export interface IKisOrderPK {
    SENDER: string;
    ORDERNR: string;
}

/**
 * The primary key of a KISIM event record.
 */
export interface IKisEventPK {
    SENDER: string;
    EVENTNR: string;
}

/**
 * The primary key of a KISIM MetaKat record.
 */
export interface IKisMetaKatPK {
    ICODE: string;
}

/**
 * The primary key of a KISIM report record.
 */
export interface IKisReportPK {
    SENDER: string;
    REPORTNR: string;
}

/**
 * The primary key of a KISIM lab report record.
 */
export interface IKisLabReportPK {
    SENDER: string;
    REPORTNR: string;
}

/**
 * The primary key of a KISIM termin record.
 */
export interface IKisTerminPK {
    TERMNR: string;
}

/**
 * The primary key of a KISIM workitem record.
 */
export interface IKisWorkItemPK {
    WORKID: string;
}

/**
 * A type to specify the primary key of any kind of KISIM object.
 */
export type AnyKisObjectPK =
    | IKisPatientPK
    | IKisCasePK
    | IKisOrderPK
    | IKisEventPK
    | IKisMetaKatPK
    | IKisReportPK
    | IKisLabReportPK
    | IKisTerminPK
    | IKisWorkItemPK;

/**
 * Used to get objects of certain KAT-FKEY-combinations.
 */
export interface IKatFkey {
    KAT: string;
    FKEY?: string | undefined;
    kisimObjectType?: KisObjectKind;
}

/**
 *  Defines who needs to approve something
 */
export enum ApprovalBy {
    none,
    currentUser,
    somebodyElse,
    both,
    unknown,
    other,
}

export type CaseTypes = 'S' | 'A' | 'T';

export type CaveEntryType = 'Allergies' | 'BloodType' | 'InfectionRisks' | 'LivingWill';

export type NewEventSetup = {
    attemptQuickDoc?: boolean;
    cloneEventData?: EventData;
    fallNr: string;
    fcode: string;
    fkey: string;
    hotspot?: string;
    kat: string;
    filterOrder?: (order: OrderData) => boolean; // used as additional filter to determine whether a Verordnung can be used as refOrder
    order?: OrderData;
    patNr: string;
    title?: string;
    valueOverride?: ValueSet;
};

export type NewMultiEventSetup = {
    fallNr: string;
    patNr: string;
    newEventSetups: NewEventSetup[];
    name: string;
};

export type EditEventSetup = {
    sender: string;
    eventnr: string;
    patnr: string;
    valueOverride?: ValueSet;
    attemptQuickDoc?: boolean;
    followUpAction?: any;
    order?: OrderData;
};

export interface AppointmentSelector {
    fallnr?: string;
    fcode: string;
    type: string;
    patnr: string;
}

export interface EventTypeSelector {
    fcode?: string;
    fkey: string;
    kat: string;
}

export interface EventSelector {
    fallnr?: string;
    fcode?: string;
    fkey: string;
    kat: string;
    ordernr?: string;
    patnr: string;
    sender?: string;
}

export interface OrderTypeSelector {
    fcode?: string;
    fkey: string;
    kat: string;
}
